import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Subhero from "../components/subhero"
import text from "../styles/typography.module.scss"
import Img from "gatsby-image"
import "../styles/news.scss"

export default function Home({ data }) {
  return (
    <Layout>
      <SEO 
        title={"Newest updates"}
        description={"Read more about the latest news"}
      />
      <Subhero>
        <h1 className={text.heading1}>Latest News</h1>
      </Subhero>

      <div className="blogParent">
        <div className="blogGrid">
          {data.allMarkdownRemark.edges.map(({ node }) => (
            <div className="blogPost" key={node.id}>
              <Link to={node.fields.slug}>
                <Img
                  fluid={node.frontmatter.featuredImage.childImageSharp.fluid}
                />
                <div className="blogInfo">
                  <h2 className={text.heading2}>{node.frontmatter.title} </h2>
                  <p className={text.paragraph}>{node.excerpt}</p>
                  <div className="blogExtras">
                    <p className={text.paragraph}>
                      {node.timeToRead} minutes read
                    </p>
                    <span className="spacer">-</span>
                    <span className={text.paragraph}>
                      {node.frontmatter.date}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD. MMMM YYYY")
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 800, maxHeight: 450) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          timeToRead
          excerpt
        }
      }
    }
  }
`
